'use client';
var classes = {"root":"m-e2125a27","closeButton":"m-5abab665"};

export default classes;
//# sourceMappingURL=Dialog.module.mjs.map
